export default {
    //统计点击
    clickSk: function(id, product_id)
    {
        if(id && product_id){
            var data = {
                id: id,
                product: product_id,
                type: "1",
            };
            httpRequest("/c.json?t="+Math.random(), data);
        }
    },
    getdata: function(data) {

        if(this.isEmpty(data)) return false;
        
        var maxweight = 0;
        data.forEach(function (e) {
            maxweight += e.weight;
        });
        if(maxweight<=0){
            return false;
        }
        //随机数
        var random = Math.floor(Math.random() * maxweight);
        var weight = 0;
        var key = 0;
        var result = {'data':[], 'item':''};
        for (let i = 0; i < data.length; i++)
        {
            weight += data[i].weight;

            if(random>=(weight-data[i].weight) && random<weight){
                result.item = data[i];
            }else{
                result.data[key] = data[i];
                key += 1;
            }
        }
        return result;
    },
    getDatas: function(data, number)
    {
        if(this.isEmpty(data)) return false;

        var new_data = [];
        var key = 0;
        for (let i=0; i<number; i++)
        {
            var result = this.getdata(data);
            if(result){
                new_data[key] = result.item;
                key += 1;
            }else{
                i = number;
            }
            data = result.data;
        }
        return new_data;
    },
    getDatasAsc: function(data, start=0, last=5)
    {
        if(this.isEmpty(data)) return false;

        var new_data = [];
        var key = 0;
        for (let i=start; i<(start+last); i++)
        {
            if(data[i])
            {
                new_data[key] = data[i];
                key += 1;
            }
        }
        return new_data;
    },
    decodeHtmlEntity: function(str){
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = str;
        return tempDiv.textContent || tempDiv.innerText || "";
    },
    decryptSearch: function(key){
        this.open('/search.htm?search='+key);
    },
    open: function(url, target=""){
        if(target){
            window.open(url, '_blank');
        }else{
            window.location.href = url;
        }
    },
    //移位加密解密,url，断一点字符串使用
    _enc: function(str) {
        return btoa(
            str.split('')
            .map(c => String.fromCharCode((c.charCodeAt(0) << 1) ^ 9))
            .join('')
        );
    },
    _dec: function(str) {
        return atob(str)
            .split('')
            .map(c => String.fromCharCode((c.charCodeAt(0) ^ 9) >> 1))
            .join('');
    },
    getGGUrl: function(row){
        if(!row){
            return false;
        }
        const now = new Date();
        
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        
        if(/baidu/g.test(ua) && row.is_baodu=='2')
        {
            return Group['iframe_url'].replace("https://", "https://"+getRandomString(Math.floor(Math.random()*10)+6))+"/iframe.html?encurl="+_enc(row.android_url);
        }
        else
        {
            return decodeHtmlEntity(row.android_url);
        }
    },
    isEmpty: function(value)
    {
        // 先排除 null 和 undefined（== null 会同时匹配 null 和 undefined）
        if (value == null) return true;
        
        // 再排除 NaN（注意：NaN !== NaN，所以不能用 === 判断）
        if (typeof value==='number' && isNaN(value)) return true;

        // 如果是字符串，可能还需要排除空字符串 ''
        // 根据你的需求决定是否加下面这行
        if (value === '') return true;

        return false;
    },
}
